// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ColumnsContainer, SectionComponent, View } from "@components";

type Props = $Exact<{
  data: *,
  ...PropsFromLocalize,
}>;

export const ReferralEmployeeDetailsSection = ({ data, t }: Props) => {
  return (
    <ColumnsContainer
      title={t("EMPLOYEE_DETAILS")}
      rows={[
        {
          columns: [
            {
              data: [
                [`${t("EMPLOYEE_NAME")}:`, ""],
                [`${t("EMPLOYEE_REF")}:`, ""],
                [`${t("EMPLOYMENT_START_DATE")}:`, ""],
                [`${t("JOB_TITLE")}:`, ""],
                [`${t("DEPARTMENT")}:`, ""],
                [`${t("DATE_OF_BIRTH")}:`, ""],
              ],
            },
            {
              data: [
                [`${data.firstName} ${data.lastName}`, ""],
                [data.employeeRef, ""],
                [data.activeFrom, ""],
                [data.jobTitles, ""],
                [data.departments, ""],
                [data.dateOfBirth, ""], // no need to format the date, it's already returned as required format
              ],
            },
          ],
        },
      ]}
    />
  );
};
